var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 233,
    viewBox: "0 0 210 233",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_967_31539)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -50,
    width: 310,
    height: 233,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-50 173.545H260V233H-50V173.545Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.939 77.575L111.277 88.2417H105.946V66.1392H95.3343H66.5343C64.1166 66.1392 61.7999 67.1006 60.1004 68.8109L50.9961 77.9191H83.6403C86.058 77.9191 88.3746 78.8805 90.0741 80.5908L105.612 96.1355H137.477L166.126 67.475C167.016 66.5844 168.179 66.1392 169.342 66.1392H164.528H121.939V77.575Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6892 118.896H94.2413C95.4957 118.896 96.5174 117.873 96.5174 116.619V102.956C96.5174 101.701 95.4957 100.679 94.2413 100.679H89.6892C88.4348 100.679 87.4131 101.701 87.4131 102.956V116.619C87.4131 117.873 88.4247 118.896 89.6892 118.896Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2351 77.9087L10.0264 96.1251V173.545H19.1307V150.774C19.1307 145.744 23.2074 141.666 28.2351 141.666C33.2627 141.666 37.3394 145.744 37.3394 150.774V173.545H46.4437V96.1251L28.2351 77.9087ZM32.7872 125.727C32.7872 126.982 31.7655 128.004 30.5111 128.004H25.959C24.7046 128.004 23.6829 126.982 23.6829 125.727V102.784C23.6829 101.529 24.7046 100.507 25.959 100.507H30.5111C31.7655 100.507 32.7872 101.529 32.7872 102.784V125.727Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.94 77.5746V66.1287V56.2412H111.277V88.2312L121.94 77.5746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4802 118.896H80.5845C81.8389 118.896 82.8606 117.873 82.8606 116.619V102.956C82.8606 101.701 81.8389 100.679 80.5845 100.679H71.4802C70.2258 100.679 69.2041 101.701 69.2041 102.956V116.619C69.2041 117.873 70.2157 118.896 71.4802 118.896Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.174 150.774C105.146 150.774 101.069 154.853 101.069 159.883V173.545H119.278V159.883C119.278 154.843 115.201 150.774 110.174 150.774Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3252 123.45V173.545H78.3086V146.22L55.3252 123.45Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8239 118.896H62.3761C63.6305 118.896 64.6522 117.873 64.6522 116.619V102.956C64.6522 101.701 63.6305 100.679 62.3761 100.679H57.8239C56.5696 100.679 55.5479 101.701 55.5479 102.956V116.619C55.5479 117.873 56.5594 118.896 57.8239 118.896Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.837 146.109H148.868C147.614 146.109 146.592 147.131 146.592 148.386V173.545H167.835C176.474 173.545 192.114 173.545 192.114 173.545V148.386C192.114 147.121 191.092 146.109 189.837 146.109Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.622 96.125V123.45L128.383 146.22V173.545H137.487V96.125H105.622Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.622 123.45V96.125H46.4434V173.545H55.3252V123.45H105.622ZM87.4129 102.956C87.4129 101.701 88.4346 100.679 89.689 100.679H94.2412C95.4956 100.679 96.5173 101.701 96.5173 102.956V116.618C96.5173 117.873 95.4956 118.895 94.2412 118.895H89.689C88.4346 118.895 87.4129 117.873 87.4129 116.618V102.956ZM69.2042 102.956C69.2042 101.701 70.2259 100.679 71.4803 100.679H80.5847C81.839 100.679 82.8607 101.701 82.8607 102.956V116.618C82.8607 117.873 81.839 118.895 80.5847 118.895H71.4803C70.2259 118.895 69.2042 117.873 69.2042 116.618V102.956ZM55.5477 102.956C55.5477 101.701 56.5694 100.679 57.8238 100.679H62.376C63.6303 100.679 64.6521 101.701 64.6521 102.956V116.618C64.6521 117.873 63.6303 118.895 62.376 118.895H57.8238C56.5694 118.895 55.5477 117.873 55.5477 116.618V102.956Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3086 146.22V173.545H101.069V159.883C101.069 154.853 105.146 150.774 110.174 150.774C115.201 150.774 119.278 154.853 119.278 159.883V173.545H128.382V146.22H78.3086Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.218 96.1252L172.57 67.4648C171.679 66.5742 170.516 66.1289 169.353 66.1289C168.189 66.1289 167.026 66.5742 166.136 67.4648L137.487 96.1252V173.545H146.592V148.386C146.592 147.131 147.613 146.109 148.868 146.109H189.837C191.092 146.109 192.113 147.131 192.113 148.386V173.545H201.218V113.491V96.1252ZM173.905 116.619C173.905 117.874 172.883 118.896 171.629 118.896H167.076C165.822 118.896 164.8 117.874 164.8 116.619V93.8482C164.8 92.5933 165.822 91.5711 167.076 91.5711H171.629C172.883 91.5711 173.905 92.5933 173.905 93.8482V116.619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.276 88.2312V56.2412H105.945V66.1287V88.2312H111.276Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.622 96.1251L90.084 80.5804C88.3744 78.8701 86.0577 77.9087 83.6501 77.9087H51.006H28.2451L46.4538 96.1251H105.622Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3086 146.22H128.382L105.622 123.45H55.3252L78.3086 146.22Z",
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2352 141.666C23.2076 141.666 19.1309 145.744 19.1309 150.774V173.545H37.3396V150.774C37.3396 145.734 33.2628 141.666 28.2352 141.666Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.628 91.5713H167.076C165.822 91.5713 164.8 92.5934 164.8 93.8483V116.619C164.8 117.874 165.822 118.896 167.076 118.896H171.628C172.882 118.896 173.904 117.874 173.904 116.619V93.8483C173.904 92.5833 172.882 91.5713 171.628 91.5713Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5109 100.507H25.9587C24.7043 100.507 23.6826 101.529 23.6826 102.784V125.717C23.6826 126.972 24.7043 127.994 25.9587 127.994H30.5109C31.7652 127.994 32.787 126.972 32.787 125.717V102.784C32.787 101.529 31.7652 100.507 30.5109 100.507Z",
    fill: "#DEDEDE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_967_31539"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16345 7.16344 0 16 0H210V233H16C7.16344 233 0 225.837 0 217V16Z",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome1);
export default __webpack_public_path__ + "static/media/home1.b2afebe2.svg";
export { ForwardRef as ReactComponent };